import {Pipe, PipeTransform} from "@angular/core";
import {Telephone} from '@app/_model';

@Pipe({
  name: 'telephoneText',
  standalone: true
})
export class TelephoneTextPipe implements PipeTransform {
  public transform(telephone: Telephone | undefined | null): string {
    if (!telephone) {
      return "";
    }
    let retval: string = "";
    if (telephone.country && telephone.area && telephone.local) {
      retval = telephone.country + telephone.area + telephone.local;
      if (telephone.ext) {
        retval += "/" + telephone.ext;
      }
    } else if (telephone.text) {
      retval = telephone.text;
    }
    return retval;
  }
}
